import Section from '../Section';

export default class RichText extends Section {

}
